import React, { useEffect } from 'react'
import MaterialTable, { MTableToolbar } from 'material-table'
import { Chip, LinearProgress } from '@material-ui/core'
import { Strings } from '../../assets/res/en'
import groupDataColumn from '../../dataColumns/groupDataColumn'
import useGroups from '../../hooks/modules/group/useGroups'
import useTableIcons from '../../hooks/useTableIcons'
import { SearchBar } from '../../components/searchBox/SearchBar'
import useStyles from '../../hooks/useStyles'
import Unauthorized from '../../components/Unauthorized'

function Groups() {
    const classes = useStyles()
    const { columns, sytlingOptions } = groupDataColumn()
    const { tableIcons } = useTableIcons()
    const {
        editOptions,
        groups,
        isLoading,
        getAllGroups,
        searchOptions,
        actions,
        filters,
        groupPermission
    } = useGroups()

    useEffect(() => {
        getAllGroups()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            {
                groupPermission.read === true ?
                    <>
                        <SearchBar options={searchOptions} />
                        <MaterialTable
                            title={Strings.MENU_GROUPS_TITLE}
                            icons={tableIcons}
                            columns={columns}
                            data={groups}
                            editable={editOptions}
                            options={sytlingOptions}
                            actions={actions}
                            isLoading={isLoading}
                            localization={{ body: { editRow: { deleteText: Strings.COLUMN_GROUP_DELETE_TEXT } } }}
                            components={{
                                Toolbar: props => (
                                    <div>
                                        <MTableToolbar {...props} />
                                        <div className={filters.length > 0 ? classes.filterContainer : ""}>
                                            {
                                                filters.map(fItem => (
                                                    fItem.isClearAll ?
                                                        <Chip key={fItem.name} color="secondary" label="Reset" onClick={fItem.clearAll} /> :
                                                        <Chip key={fItem.name} color="default" label={fItem.value} onDelete={fItem.remove} />))
                                            }
                                        </div>
                                    </div>
                                )
                            }}
                        />
                    </>
                    : groupPermission.read === false ?
                    <Unauthorized />:
                    <LinearProgress/>
            }
        </>
    )
}
export default Groups